import { useState } from "react";
import validateForm from "../../../utils/Validation";
import { EDIT_BUDGET } from "../../../config/API_Collection";
import Axios from "../../../utils/Axios";
import AuthHandler from "../../../utils/AuthHandler";
import { useNavigate } from "react-router-dom";

const EditBudget = ({
  editData,
  showToast,
  CloseModalEdit,
  refreshProjectData,
  setToast,
}) => {
  const navigate = useNavigate();
  const [isSubmittingEdit, setIsSubmittingEdit] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const handleEditBudget = async (e) => {
    e.preventDefault();
    if (isSubmittingEdit) return;
    setIsSubmittingEdit(true);

    try {
      const formData = e.target;
      const payload = {
        budget_id: parseInt(editData.budget_id),
        budget_name: formData.budget_name.value,
        budget_type: formData.budget_type.value,
        allocated_amount: formData.allocated_amount.value,
      };

      const requiredFields = ["budget_name", "budget_type", "allocated_amount"];
      const errors = validateForm(payload, requiredFields);
      setFormErrors(errors);

      if (Object.keys(errors).length > 0) {
        setIsSubmittingEdit(false); // re-enable on validation failure
        return;
      }

      const response = await Axios.post(EDIT_BUDGET, payload);
      if (response.status === 200) {
        showToast("Budget Updated Successfully!", "success");
        CloseModalEdit();
        refreshProjectData();
        return; // keep disabled; modal is closing
      }

      showToast(response?.data?.message || "Failed to update budget", "failed");
      setIsSubmittingEdit(false); // re-enable on API failure
    } catch (error) {
      AuthHandler(error.response?.status, setToast, navigate);
      showToast(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to update budget",
        "failed"
      );
      setIsSubmittingEdit(false); // re-enable on error
    }
  };

  return (
    <div className="add-budget-container">
      <form className="budget-form" onSubmit={handleEditBudget}>
        <fieldset
          disabled={isSubmittingEdit}
          style={{ border: 0, padding: 0, margin: 0 }}
        >
          <div className="form-row">
            <div
              className={`form-group flex-item ${
                formErrors.budget_name ? "has-error" : ""
              }`}
            >
              <label>Budget Name *</label>
              <input
                type="text"
                name="budget_name"
                defaultValue={editData.budget_name}
              />
            </div>
          </div>

          <div className="form-row">
            <div
              className={`form-group flex-item ${
                formErrors.budget_type ? "has-error" : ""
              }`}
            >
              <label>Budget Type *</label>
              <select name="budget_type" defaultValue={editData.budget_type}>
                <option value="Time">Time</option>
                <option value="Expenses">Expenses</option>
              </select>
            </div>

            <div
              className={`form-group flex-item ${
                formErrors.allocated_amount ? "has-error" : ""
              }`}
            >
              <label>Budget Amount (NZD) *</label>
              <input
                type="number"
                name="allocated_amount"
                defaultValue={editData.allocated_amount}
              />
            </div>
          </div>

          <div className="d-flex justify-content-center">
            {" "}
            <button type="submit" className="btn btn-primary">
              {isSubmittingEdit ? "Updating..." : "Update Budget"}
            </button>
            <button
              type="button"
              className="btn btn-secondary ms-2"
              onClick={CloseModalEdit}
            >
              Cancel
            </button>
          </div>
        </fieldset>

        {/* Cancel stays enabled */}
      </form>
    </div>
  );
};

export default EditBudget;
